import { Button, Input, InputGroup } from "reactstrap";
import { useAppDispatch } from "../../../../reduxToolkit/hooks";
import { decrementData, incrementData } from "../../../../reduxToolkit/reducers/eCommerce/cartSlice";
import { QuantityFieldProp, CartItems } from "../../../../types/Ecommerce";

// This component handles the quantity field for each product in the cart. It allows the user to increase or decrease the quantity of a product.
const QuantityField: React.FC<QuantityFieldProp> = ({ item }) => {

  const dispatch = useAppDispatch();
  const incrementQty = (product: CartItems, quantity: number) => dispatch(incrementData({ item: product, quantity: quantity }));

  return (
    <td>
      <fieldset className="qty-box w-50 border-0">
        <InputGroup className="d-flex flex-nowrap">
          <Button color="primary" className="btn-square bootstrap-touchspin-down" onClick={() => dispatch(decrementData(item.id))}>
            <i className="fa fa-minus"></i>
          </Button>
          <Input className="touchspin text-center" type="text" name="quantity" value={item.total} readOnly />
          <Button color="primary" className="btn-square bootstrap-touchspin-up" onClick={() => incrementQty(item, 1)}>
            <i className="fa fa-plus"></i>
          </Button>
        </InputGroup>
      </fieldset>
    </td>
  );
};

export default QuantityField